var exports = {
  "AS": "item__GhVZ6J",
  "DR": "Box_0___DdEVw",
  "IR": "GitHubAvatar_0__LlOcIQ",
  "QC": "displayName__vz3s9U",
  "bv": "boldText__B3XpAY",
  "RG": "normalText__haV_1j",
  "wy": "Box_1__5P0h5V",
  "SF": "ActionList_Description__UqFMNI",
};

module.exports = exports;
